module.exports = __webpack_public_path__ + "img/content4-2.bc383b1a.png";